

























































import wx from "weixin-jsapi";
import {
  getOperId,
  postAppId,
  getAccount,
  accountOrderPay,
} from "../../api/api.config";
import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class Order extends Vue {
  checked: boolean = true;
  code: any = "";
  appid: any = "";
  payOrds: any = {};
  timeout: any = null;
  lists: any = {};
  disabled: boolean = false;
  flag: boolean = false;
  shopData: any = "";
  shopList: any = [];
  checkedValue: any = "";
  // channeObj: any = {}
  mounted() {
    // this.getAccounts()
    this.shopData = localStorage.getItem("shopData");
    // this.channeObj = JSON.parse(localStorage.getItem('channeObj') || '')
  }

  changes(e: any) {
    this.checked = e.target.checked;
    console.log(e);
  }

  toSearch() {
    // this.disabled = true
    this.$toast.loading({
      duration: 0, // 持续展示 toast
      message: '加载中...',
      forbidClick: true,
      loadingType: "spinner",
    });
    // if (!this.checked) return this.$toast.fail('请选择支付方式')
    // if (this.checkedValue === '' && this.shopData == 1) {
    //   return this.$toast.fail('请选择支付方式')
    // }
    let openId = localStorage.getItem("openId");
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    let {
      discountPrice,
      drivingLicenseImg,
      productId,
      productName,
      sign,
      vin,
      orderId,
      dcardno,
    } = this.lists;
    let prolist = {
      discountPrice,
      drivingLicenseImg,
      productId,
      productName,
      sign,
      vin,
      openId,
      orderId,
      dcardno,
      payType: this.checkedValue,
      // channelName: this.channeObj.channelName,
      // channelCode: this.channeObj.channelCode
    };
    this.timeout = setTimeout(() => {
      if (this.shopData == 0) {
        postAppId(prolist)
          .then((res) => {
            this.payOrds = res.data.data;
            if (res.data.code === "0" && this.lists.discountPrice > 0) {
              this.$toast.clear();
              this.$nextTick(() => {
                this.permissions();
                this.perMyorder();
              });
            } else if (res.data.code === "0" && this.lists.discountPrice <= 0) {
              this.$toast.success("订单支付成功");
              this.$router.push({
                name: "Homes",
              });
            } else {
              this.$toast.fail("订单支付失败");
            }
          })
          .catch((err) => {
            console.log(err);
          });
       } else {
        // accountOrderPay(prolist).then((res) => {
        //   if (res.data.code === "0") {
        //     this.$toast.success("订单支付成功");
        //     this.$router.push({
        //       name: "Homes",
        //     });
        //   } else {
        //     this.$toast.fail("订单支付失败");
        //   }
        // })
      }
    }, 2000);
  }
  // 权限验证
  permissions() {
    console.log(1)
    wx.config({
      debug: false, // 这里一般在测试阶段先用ture，等打包给后台的时候就改回false,
      appId: this.payOrds.appId, // 必填，公众号的唯一标识
      timestamp: this.payOrds.timeStamp, // 必填，生成签名的时间戳
      nonceStr: this.payOrds.nonceStr, // 必填，生成签名的随机串
      signature: this.payOrds.paySign, // 必填，签名
      jsApiList: ['chooseWXPay'], // 必填，需要使用的JS接口列表
    })
  }
  // 支付
  perMyorder() {
    let that = this
    wx.chooseWXPay({
      timestamp: this.payOrds.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
      nonceStr: this.payOrds.nonceStr, // 支付签名随机串，不长于 32 位
      package: this.payOrds.packageValue, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
      signType: this.payOrds.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
      paySign: this.payOrds.paySign, // 支付签名
      success: function (reses: any) {
        console.log(reses, '支付成功的回调')
        that.$toast.success('支付成功')
        that.$router.push({
          name: 'Homes',
        })
        that.disabled = false
      },
      fail: function (reses: any) {
        console.log(reses, '支付失败的回调')
        that.$toast.fail(reses + '支付失败')
        // that.disabled = false;
      },
    })
  }

  // 门店信息
  // getAccounts() {
  //   getAccount().then((res: any) => {
  //     if (res.data.code == 0) {
  //       this.shopList = res.data.data
  //     } else {
  //       this.$toast.fail(res.message)
  //     }
  //   })
  // }

  created() {
    this.lists = this.$route.query.list;
    Number(this.lists.dcardno);
  }
}
